import { DocumentCardType } from "office-ui-fabric-react";
import * as React from "react";
import { OfficeHostType } from "../interfaces/index";
import { DocumentCardBasic } from "./DocumentCardBasic";
export var OfficeClientPanel = function OfficeClientPanel(props) {
  var wordTemplate = {
    title: props.strings.Word,
    hostType: OfficeHostType.Word,
    id: "Word",
    name: props.strings.Word,
    parentReference: {}
  };
  var excelTemplate = {
    title: props.strings.Excel,
    hostType: OfficeHostType.Excel,
    id: "Excel",
    name: props.strings.Excel,
    parentReference: {}
  };
  var pptTemplate = {
    title: props.strings.PowerPoint,
    hostType: OfficeHostType.PowerPoint,
    id: "PowerPoint",
    name: props.strings.PowerPoint,
    parentReference: {}
  };

  var selectedHost = function selectedHost(t) {
    props.selectHost(t.hostType);
  };

  return React.createElement("div", null, React.createElement("div", {
    className: "subTitle"
  }, props.strings.ForWhichApplication), React.createElement("div", {
    className: "officeClients"
  }, React.createElement(DocumentCardBasic, {
    onClick: selectedHost,
    template: wordTemplate,
    strings: props.strings,
    cardType: DocumentCardType.normal
  }), React.createElement(DocumentCardBasic, {
    onClick: selectedHost,
    template: excelTemplate,
    strings: props.strings,
    cardType: DocumentCardType.normal
  }), React.createElement(DocumentCardBasic, {
    onClick: selectedHost,
    template: pptTemplate,
    strings: props.strings,
    cardType: DocumentCardType.normal
  }), React.createElement("div", {
    style: {
      clear: "both"
    }
  })));
};